import { useEffect } from 'react'
import { isNil, isNotNil } from '../../../shared/lib/functional/nil.no-deps'

export function useScrollIntoView(elementId: string) {
    useEffect(() => {
        if (isNil(elementId)) {
            return
        }

        const element = document.getElementById(elementId)
        if (isNotNil(element)) {
            element.scrollIntoView()
            return
        }

        const observer = new MutationObserver(() => {
            const element = document.getElementById(elementId)
            if (isNotNil(element)) {
                element.scrollIntoView()
                observer.disconnect()
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })

        return () => {
            observer.disconnect()
        }
    }, [elementId])
}
